module.exports = __webpack_public_path__ + "img/background.16b4b30c.jpg";